import { type Interval, isEqualTime } from "./date-fns";

export function isIntervalEqual(left: Interval, right: Interval): boolean {
	return isEqualTime(left.start, right.start) && isEqualTime(left.end, right.end);
}
